var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.60001 6.00005C3.60001 5.33731 4.13726 4.80005 4.80001 4.80005H19.2C19.8627 4.80005 20.4 5.33731 20.4 6.00005C20.4 6.66279 19.8627 7.20005 19.2 7.20005H4.80001C4.13726 7.20005 3.60001 6.66279 3.60001 6.00005Z",
    fill: "#4318FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.60001 12C3.60001 11.3373 4.13726 10.8 4.80001 10.8H19.2C19.8627 10.8 20.4 11.3373 20.4 12C20.4 12.6628 19.8627 13.2 19.2 13.2H4.80001C4.13726 13.2 3.60001 12.6628 3.60001 12Z",
    fill: "#4318FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.60001 18C3.60001 17.3373 4.13726 16.8 4.80001 16.8H12C12.6627 16.8 13.2 17.3373 13.2 18C13.2 18.6628 12.6627 19.2 12 19.2H4.80001C4.13726 19.2 3.60001 18.6628 3.60001 18Z",
    fill: "#4318FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.6eaf91c1f4ea6905b811794269e99507.svg";
export { ForwardRef as ReactComponent };